import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { JetBrains_Mono, Orbitron, Space_Grotesk } from 'next/font/google'

const sans = Space_Grotesk({
    subsets: ['latin']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const heading = Orbitron({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
